import React from "react";

type ProgressBarProps = {
  progress: number;
};

export const ProgressBar = (props: ProgressBarProps) => {
  return (
    <div
      style={{
        alignSelf: "center",
        width: "80vw",
        backgroundColor: "rgba(0,0,0,0.9)",
        height: "40px",
        borderRadius: "16px",
        margin: "0 auto",
        padding: "5px",
      }}
    >
      <div
        style={{
          width: `${props.progress * 100}%`,
          height: "40px",
          backgroundColor: "rgba(50, 255, 50, 0.8)",
          borderRadius: "16px",
        }}
      >
      </div>
    </div>
  );
};
